type ErrorProps = {
  errorText: string;
};

export function Error({errorText}: ErrorProps): JSX.Element {
  return (
    <>
      <div>
        <div>{errorText}</div>
      </div>
    </>
  );
}
